export default {
    prompt:"Header Max Width",
    field:"--maxWidth",
    type:"style",
    default:2500,
    property:"--maxWidth",
    range:[0,2500],
    slider:true,
    unit:"px"
}